export enum DeployStatus {
    Ready = "ready",
    Deprecated = "deprecated",
    RolledBack = "rolled_back",
}

export enum DeployEnvironment {
    Production = "production",
    Staging = "staging",
    Preview = "preview",
}
